/**
 * Owner: Masa Bayu
 * File: element-layout.ts
 * Date:Time: 2026-09-05 06:59
 * Description: Neutral layout box contract for QXW elements.
 */
export const QX_DEFAULT_TEXT_LAYOUT = {
    mode: 'absolute',
    x: 0,
    y: 0,
    width: 200,
    height: 50,
    rotation: 0,
    zIndex: 0,
};
export const QX_DEFAULT_MEDIA_LAYOUT = {
    mode: 'absolute',
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    rotation: 0,
    zIndex: 0,
};
//# sourceMappingURL=element-layout.js.map